import React, { createContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { apiInstance, routes } from "../../helpers/API";
import { generalActions } from "../../store/actions";
import moment from "moment";

const SharedTimelineContext = createContext();

const SharedTimelineContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [displayYearRange, setdisplayYearRange] = useState({start: moment().year(), end: moment().year()});
  const [tabView, setTabView] = useState("month");
  const [todayTrigger, setTodayTrigger] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timelineData, setTimelineData] = useState([]);
  const [timelineKeyEvents, setTimelineKeyEvents] = useState([]);
  const [timelineMilestones, setTimelineMilestones] = useState([]);
  const [entityID, setEntityID] = useState(null);
  const [entityType, setEntityType] = useState("program");
  const settings = JSON.parse(localStorage.getItem("settings"));

  const fetchAndSetTimelineData = async () => {
    try {
      setIsLoading(true);
      if (!entityID) return;

      let endpoint;
      if (entityType === "program") {
        endpoint = routes.getProgramTimeline.replace(":id", entityID);
      } else if (entityType === "project") {
        endpoint = routes.getProjectTimeline.replace(":id", entityID);
      } else if (entityType === "portfolio") {
        endpoint = routes.getPortfolioTimeline.replace(":id", entityID);
      }

      const res = await apiInstance.get(
        `${endpoint}?view=${tabView}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              ?.getItem("accessToken")
              ?.replace(/"/g, "")}`,
          },
        }
      );

      setdisplayYearRange({start: res?.data?.yearRange?.start, end: res?.data?.yearRange?.end});
      
      setTimelineMilestones(res?.data?.milestones ?? []);
      if (entityType === "program") {
        // Map projects with their scopeItems
        const projects = res?.data?.projects ?? [];
        const mappedProjects = projects.map(project => ({
          ...project,
          scopeItems: project.scopeItems || project.scopes || []
        }));
        setTimelineData(mappedProjects);
      } else if (entityType === "portfolio") {
        setTimelineData(res?.data?.programs ?? []);
        setTimelineKeyEvents(res?.data?.keyEvents ?? []);
      } else {
        setTimelineData(
          res?.data
            ? Array.isArray(res.data)
              ? res.data
              : [res.data]
            : []
        );
      }
    } catch (error) {
      return dispatch(
        generalActions.showToast({
          title: error.message,
          type: "error",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
      fetchAndSetTimelineData();
  }, [tabView, entityID, entityType]);

  return (
    <SharedTimelineContext.Provider
      value={{
        entityID,
        setEntityID,
        entityType,
        setEntityType,
        displayYearRange,
        tabView,
        todayTrigger,
        isLoading,
        setTabView,
        setTodayTrigger,
        fetchAndSetTimelineData,
        timelineData,
        timelineKeyEvents,
        setTimelineData,
        timelineMilestones,
        settings
      }}
    >
      {children}
    </SharedTimelineContext.Provider>
  );
};

export { SharedTimelineContext, SharedTimelineContextProvider };